module.exports = __webpack_public_path__ + "img/mood-icon-1.8ac69b5a.svg";